import { useRecoilState } from 'recoil'

import { debugSettingsAtom } from '../state/debug-settings.atoms'

import type { DebugSettings } from '../state/debug-settings.atoms'

export const useDebugSettings = () => {
  const [debugSettings, setDebugSettings] = useRecoilState(debugSettingsAtom)

  const updateDebugSettings = (newSettings: Partial<DebugSettings>) => {
    setDebugSettings((previous) => ({ ...previous, ...newSettings }))
  }

  return { debugSettings, updateDebugSettings }
}
